export default __webpack_public_path__ + "static/media/1.ad86505b.svg";